/**
 * Aggregate validation methods from sub-components
 * and reduce the validation result from all of them.
 */
export default class ValidationAggregator {
    components = {};

    aggregatedResult = false;

    hasErrors = false;

    /**
     * Register a unique-named component
     * and its rules for future validation.
     * @param {string} name
     * @param {Array} rules
     * @param {Function} beforeValidation?
     */
    registerComponent({name, rules, beforeValidation = () => {}}) {
        this.components[name] = {rules, beforeValidation};
    }

    /**
     * Remove the component from the aggregate validator and
     * prevent it from creating missing reference errors at runtime.
     * @param {string} name
     */
    deregisterComponent(name) {
        Reflect.deleteProperty(this.components, name);
    }

    /**
     * Reduce the validation result into a boolean when everything
     * is valid or an array if one or more validations failed within
     * the aggregator.
     * @returns {boolean|Array}
     */
    validateAggregated() {
        const aggregatedResult = Object.keys(this.components)
            .reduce((result, componentName) => {
                const {rules, beforeValidation} = this.components[componentName];
                const lines = typeof rules === typeof Function
                    ? rules()
                    : rules;
                beforeValidation.call(null);
                lines.forEach((rule) => {
                    const {name, delegate} = rule;
                    if (delegate()) {
                        result.push({
                            name,
                            result: false,
                        });
                    }
                });
                return result;
            }, []);

        this.hasErrors = aggregatedResult.length > 0;
        this.aggregatedResult = aggregatedResult.length
            ? aggregatedResult
            : false;

        return this.aggregatedResult;
    }
}
